import { RolodexPermissions } from './permissions/rolodexPermissionsList'

/**
 * Checks to see if any of the `permissionsToCheck` are in the `userPermissions` set.
 */
export function doesHaveRequiredPermissionsBase(
  userPermissions: ReadonlySet<string> | undefined,
  permissionsToCheck: RolodexPermissions[]
): boolean {
  if (!userPermissions) {
    return false
  }

  return permissionsToCheck.some((permission) =>
    userPermissions.has(permission)
  )
}
